/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component, useState } from "react";
import { Link } from "react-router-dom";

import { withTranslation } from "react-i18next";
import i18next from "i18next";

const videos = [
    //Robotics - National Finals
    {
        id: 1,
        category: "Achievements_Videos_Robotics_National_Final",
        src: "https://www.youtube.com/embed/onzc1URiD4s",
        descriptionKey: "Videos_Description_Video17",
    },
    {
        id: 2,
        category: "Achievements_Videos_Robotics_National_Final",
        src: "https://www.youtube.com/embed/1giw4nanz5k",
        descriptionKey: "Videos_Description_Video18",
    },
    {
        id: 3,
        category: "Achievements_Videos_Robotics_National_Final",
        src: "https://www.youtube.com/embed/PRiZwk5OjcY",
        descriptionKey: "Videos_Description_Video19",
    },
    {
        id: 4,
        category: "Achievements_Videos_Robotics_National_Final",
        src: "https://www.youtube.com/embed/yVWRz50fFOQ",
        descriptionKey: "Videos_Description_Video20",
    },
    {
        id: 5,
        category: "Achievements_Videos_Robotics_National_Final",
        src: "https://www.youtube.com/embed/gspqF-pFDk",
        descriptionKey: "Videos_Description_Video21",
    },
    {
        id: 6,
        category: "Achievements_Videos_Robotics_National_Final",
        src: "https://www.youtube.com/embed/XrFS_S2lNC8",
        descriptionKey: "Videos_Description_Video22",
    },
    {
        id: 7,
        category: "Achievements_Videos_Robotics_National_Final",
        src: "https://www.youtube.com/embed/zzxPuSiUnuw",
        descriptionKey: "Videos_Description_Video23",
    },
    {
        id: 8,
        category: "Achievements_Videos_Robotics_National_Final",
        src: "https://www.youtube.com/embed/gJAD-yrDT2E",
        descriptionKey: "Videos_Description_Video24",
    },
    {
        id: 9,
        category: "Achievements_Videos_Robotics_National_Final",
        src: "https://www.youtube.com/embed/qsxmduxdSiw",
        descriptionKey: "Videos_Description_Video25",
    },
    {
        id: 10,
        category: "Achievements_Videos_Robotics_National_Final",
        src: "https://www.youtube.com/embed/y9jvkP-KRiw",
        descriptionKey: "Videos_Description_Video26",
    },
    {
        id: 11,
        category: "Achievements_Videos_Robotics_National_Final",
        src: "https://www.youtube.com/embed/vmn9CnQDuuQ",
        descriptionKey: "Videos_Description_Video27",
    },
    {
        id: 12,
        category: "Achievements_Videos_Robotics_National_Final",
        src: "https://www.youtube.com/embed/3Q-Qwc5zclc",
        descriptionKey: "Videos_Description_Video28",
    },
    {
        id: 13,
        category: "Achievements_Videos_Robotics_National_Final",
        src: "https://www.youtube.com/embed/pYPDaBx8h0s",
        descriptionKey: "Videos_Description_Video29",
    },
    {
        id: 14,
        category: "Achievements_Videos_Robotics_National_Final",
        src: "https://www.youtube.com/embed/aVOiauJlDa0",
        descriptionKey: "Videos_Description_Video30",
    },
    {
        id: 15,
        category: "Achievements_Videos_Robotics_National_Final",
        src: "https://www.youtube.com/embed/Q7c635IuBtY",
        descriptionKey: "Videos_Description_Video31",
    },
    {
        id: 16,
        category: "Achievements_Videos_Robotics_National_Final",
        src: "https://www.youtube.com/embed/VwLQJESWTzA",
        descriptionKey: "Videos_Description_Video32",
    },

    // Robotics - International Finals
    {
        id: 17,
        category: "Achievements_Videos_Robotics_Internaltional_Final",
        src: "https://youtube.com/embed/GnEqnFGWWRo?si=6RQLDnCgexTiowg4",
        descriptionKey: "Videos_Description_Video33",
    },
    {
        id: 18,
        category: "Achievements_Videos_Robotics_Internaltional_Final",
        src: "https://youtube.com/embed/kMVVmxRhl2Y?si=G-Q7MGdshr4-1f9v",
        descriptionKey: "Videos_Description_Video34",
    },
    {
        id: 19,
        category: "Achievements_Videos_Robotics_Internaltional_Final",
        src: "https://youtube.com/embed/cejb8kKOCao?si=lc9-kz-zw8uYW_Ip",
        descriptionKey: "Videos_Description_Video35",
    },
    {
        id: 20,
        category: "Achievements_Videos_Robotics_Internaltional_Final",
        src: "https://youtube.com/embed/zSjbVlw98ec?si=1_qy7_QY4JQQNd-J",
        descriptionKey: "Videos_Description_Video36",
    },
    {
        id: 21,
        category: "Achievements_Videos_Robotics_Internaltional_Final",
        src: "https://youtube.com/embed/pB0T2g2mMiE?si=6eFy7BFmbQevcSKX",
        descriptionKey: "Videos_Description_Video37",
    },
    {
        id: 22,
        category: "Achievements_Videos_Robotics_Internaltional_Final",
        src: "https://youtube.com/embed/ZWJqc7uiuA8?si=H1hShyLpUQoB7OeP",
        descriptionKey: "Videos_Description_Video38",
    },
    {
        id: 23,
        category: "Achievements_Videos_Robotics_Internaltional_Final",
        src: "https://youtube.com/embed/uOeqLP3nJe4?si=9_JCzmTvYf0r13bO",
        descriptionKey: "Videos_Description_Video38",
    },
    {
        id: 24,
        category: "Achievements_Videos_Robotics_Internaltional_Final",
        src: "https://youtube.com/embed/uoYw4PAajAg?si=6TDHjBUhosgvbgMq",
        descriptionKey: "Videos_Description_Video39",
    },
    {
        id: 25,
        category: "Achievements_Videos_Robotics_Internaltional_Final",
        src: "https://youtube.com/embed/5-W_PCLGrqg?si=hoQCvdjcgl1nRrJl",
        descriptionKey: "Videos_Description_Video40",
    },
    {
        id: 26,
        category: "Achievements_Videos_Robotics_Internaltional_Final",
        src: "https://youtube.com/embed/sIMoURR-8YA?si=5h1RzBel2WpE9ivN",
        descriptionKey: "Videos_Description_Video41",
    },
    {
        id: 27,
        category: "Achievements_Videos_Robotics_Internaltional_Final",
        src: "https://youtube.com/embed/4p2QlfnuDEc?si=7Klmi6AoMdp97Blg",
        descriptionKey: "Videos_Description_Video42",
    },
    {
        id: 28,
        category: "Achievements_Videos_Robotics_Internaltional_Final",
        src: "https://youtube.com/embed/Ns1ls2deBS0?si=7tYb9LqXrYduK2X1",
        descriptionKey: "Videos_Description_Video43",
    },
    {
        id: 29,
        category: "Achievements_Videos_Robotics_Internaltional_Final",
        src: "https://youtube.com/embed/GCtYFHzJIfo?si=cdROo_79WZP22yoN",
        descriptionKey: "Videos_Description_Video44",
    },
];

const tags_video_robotics = [
    "Achievements_Videos_Robotics_National_Final",
    "Achievements_Videos_Robotics_Internaltional_Final"
];

const FilterList = ({ dataFilter, defaultTag, activeFilter }) => {
    return (
        <li
            className={`${activeFilter ? "btn active" : "btn"}`}
            onClick={() => defaultTag(dataFilter)}
        >
            <Link to={"#"}>{dataFilter}</Link>
        </li>
    );
};

function RoboticsVideoContent() {
    const [selectedRoboticsTag, setSelectedRoboticsTag] = useState("Achievements_Videos_Robotics_National_Final");

    const filteredVideos = videos.filter((video) => {
        return video.category === selectedRoboticsTag;
    });

    return (
        <>
            <div className="container">

                {/* Robotics Sub Tabs */}
                <div className="feature-filters clearfix center m-b40">
                    <ul className="filters" data-toggle="buttons">
                        {tags_video_robotics.map((tag) => (
                            <FilterList
                                key={tag}
                                dataFilter={i18next.t(tag)}
                                defaultTag={() => { setSelectedRoboticsTag(tag); }}
                                activeFilter={selectedRoboticsTag === tag}
                            />
                        ))}
                    </ul>
                </div>

                {/* Video List */}
                {filteredVideos.map((video) => (
                    <div className="row" key={video.id}>
                        {/* Video */}
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                            <iframe
                                width="320"
                                height="200"
                                src={video.src}
                                title={i18next.t(video.descriptionKey)}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; web-share"
                                allowFullScreen
                            ></iframe><br /><br />
                        </div>

                        {/* Description */}
                        <div className="col-lg-6 col-md-12 col-sm-12 mb-4" style={{ display: 'flex', alignItems: 'center' }}>
                            <h6>{i18next.t(video.descriptionKey)}</h6>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

class RoboticsContent extends Component {
    componentDidMount() {

    }
    render() {
        return (
            <>
                <RoboticsVideoContent />
            </>
        )
    }
}

export default withTranslation()(RoboticsContent);

